export enum VoyagePortCallStates {
  PENDING = 'pending',
  CURRENT = 'in_port',
  COMPLETED = 'completed',
  TO_BE_CONFIRMED = 'to_be_confirmed',
}
